import { useState, type ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

export function CollapsibleSection({
  title,
  icon,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-xl bg-white border border-edge overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 py-3 bg-canvas hover:bg-canvas-secondary transition-colors"
        aria-expanded={open}
      >
        <span className="material-icons-round text-ink-secondary text-lg">{icon}</span>
        <span className="text-xs font-medium text-ink-tertiary uppercase tracking-wider flex-1 text-left">
          {title}
        </span>
        <span
          className="material-icons-round text-ink-tertiary text-xl transition-transform duration-200"
          style={{ transform: open ? 'rotate(180deg)' : undefined }}
        >
          expand_more
        </span>
      </button>
      {open && children}
    </div>
  );
}
